import { apiEmpleo } from "../../util/ApiEmpleo";

export type TUpdateContactServiceHolderRelationshipRequest = {
  Parentesco?: string;
};

const apiUpdateContactServiceHolderRelationship = async (
  relationshipId: string,
  relationship: TUpdateContactServiceHolderRelationshipRequest
) => {
  let res = await apiEmpleo.patch(
    `contact_service_holder_relationships/${relationshipId}`,
    relationship,
    {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    }
  );

  return res;
};

export { apiUpdateContactServiceHolderRelationship };
